import React from 'react'
import Produits from './Produits';
import Spinner from './spinner/Spinner';
import {useDispatch} from 'react-redux'
import { setProduct } from '../redux/actions/productAction';
import axios from 'axios'
import { useState, useEffect, useCallback } from 'react'
import Skeleton from 'react-loading-skeleton'



const Prods = () => {

  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);

  // const [refer, setRefer] = useState(true)


   const fetchProduits = async () => {
     setLoading(true);
     <Skeleton height={350} />
     try {
       const response = await axios.get('https://fakestoreapi.com/products')
       dispatch(setProduct(response.data))
     } catch (error) {
       console.log(error)
     }
     setLoading(false)
   }

   useEffect(() => {
       fetchProduits()
   }, [])

  return (
    <div>
      {loading ? <Spinner /> : <Produits />}
    </div>
  )
}

export default Prods